import h5Api from './h5-others'
import xbb from '@xbb/xbb-utils'

/**
 * 获取位置权限后获取当前位置
 * @param {any} onSuccess
 * @param {any} onFail
 */
function gerCurrentLocation(onSuccess, onFail) {
  window.plus.geolocation.getCurrentPosition(
    (p) => {
      const result = {
        ...p,
        ...p.coords,
        ...p.address,
        address: p.addresses
      }
      onSuccess(result)
    },
    (err) => {
      onFail(err)
    },
    {
      geocode: true,
      provider: 'amap',
      timeout: 10000
      // enableHighAccuracy: true
    }
  )
}

/**
 * 安卓环境时获取位置权限
 * @param {any} onSuccess
 * @param {any} onFail
 */
const getLocationFromJar = function ({ onSuccess, onFail }) {
  try {
    // 引入第三方jar包
    const NjsTest = window.plus.android.importClass('com.pactera.xbcrm.recorder.bridge.JsInterface')
    const activity = window.plus.android.runtimeMainActivity()
    const jsInterface = new NjsTest(activity)
    const res = jsInterface.verifyLocationPermission()
    if (res) {
      // 权限已开启
      gerCurrentLocation(onSuccess, onFail)
    } else {
      // 权限状态更新是异步的，延迟500ms直接调用定位
      setTimeout(() => {
        gerCurrentLocation(onSuccess, onFail)
      }, 500)
    }
  } catch (e) {
    h5Api.h5ChoosePermission({
      type: 3,
      onSuccess: (_) => {
        gerCurrentLocation(onSuccess, onFail)
      }
    })
  }
}

/**
 * 获取当前地理位置
 * @param {any} onSuccess
 * @param {any} onFail
 */
const xbbGetLocation = function ({ onSuccess, onFail }) {
  const system = xbb.browser()
  h5Api.h5ChoosePermission({
    type: 3,
    onSuccess: (_) => {
      if (system === 'ios') {
        gerCurrentLocation(onSuccess, onFail)
      } else {
        getLocationFromJar({ onSuccess, onFail })
      }
    },
    onFail: () => {
      if (!window.uni) {
        onFail()
      }
      uni.postMessage({ data: { type: 'getLocation' } })
    }
  })
}

export default {
  xbbGetLocation
}
